let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4PYBD")).then(() => parcelRequire('1hwjy'));